<template>
  <div class="checkbox-multi-selections">
    <div class="label">
      <label class="text-[14px]" :class="{ 'text-small': labelSmall }">{{
        $t(label)
      }}</label>
      <span class="text-[#F44336]" v-if="required"> * </span>
    </div>

    <!-- Refer for customizing: https://ej2.syncfusion.com/vue/documentation/api/multi-select#filtering -->

    <ejs-multiselect
      :placeholder="placeholder"
      v-model="localSelections"
      :dataSource="options"
      :disabled="isDisabled"
      mode="CheckBox"
      :fields="fields"
      :itemTemplate="itemTemplate"
      @filtering="$emit('filtering', $event)"
      @select="$emit('select', $event)"
      @open="$emit('open')"
      @close="$emit('close')"
      @removed="$emit('removed', $event)"
      zIndex="14"
      ref="selectboxRef"
      :showSelectAll="showSelectAll"
      :selectAllText="$t('common.select_all')"
      :unSelectAllText="$t('common.un_select_all')"
    ></ejs-multiselect>
  </div>
</template>
<script>
export default {
  model: {
    prop: "selections",
    event: "change"
  },
  props: [
    "required",
    "labelSmall",
    "placeholder",
    "label",
    "options",
    "trackBy",
    "displayField",
    "values",
    "itemTemplate",
    "showSelectAll",
    "selections",
    "isDisabled"
  ],
  data() {
    return {
      fields: {
        text: this.displayField || "name",
        value: this.trackBy || "id"
      }
    };
  },
  computed: {
    localSelections: {
      get: function() {
        return this.selections;
      },
      set: function(value) {
        this.$emit("change", value);
      }
    }
  }
};
</script>

<style lang="scss">
.checkbox-multi-selections {
  .label {
    display: block;
    margin-top: 3px;
    margin-bottom: -3px;
    color: #aaa;
    font-weight: 400;
    .text-small {
      font-size: 11px !important;
      line-height: 24px;
      letter-spacing: 0.25px;
      color: #aaaaaa;
    }
  }
}
.e-multiselect {
  border-bottom-color: #d2d2d2 !important;

  * {
    font-size: 14px;
  }
  .e-delim-values {
    font-family: "Poppins", "sans-serif";
  }

  .e-multi-select-wrapper {
    .e-searcher {
      input {
        font-size: 14px;
        font-family: "Poppins", "sans-serif";
      }
    }
  }
}
.e-multi-select-wrapper {
  select {
    option {
      font-family: "Poppins", "sans-serif";
    }
  }
}

// .e-popup .e-checkbox-wrapper .e-frame.e-check,
// .e-popup .e-checkbox-wrapper:hover .e-frame.e-check {
//   background-color: white;
//   color: #0032e3;
// }

.validate-multi-select {
  .multi-select-label {
    display: block;
    margin-top: 3px;
    margin-bottom: -3px;
    font-size: 14px;
    color: #aaa;
    font-weight: 400;
  }

  .multi-select-error {
    color: #ff5252;
    font-size: 12px;
  }
}
</style>
